const NOT_NEEDED_TAB_INDEX = -1

export enum SmartFunctionTabs {
  /* TODO: revert chagnes made in CPE-1861 */
  smartHome = NOT_NEEDED_TAB_INDEX,
  smartCharge = 0,
  smartPower = 1,
}
